// extracted by mini-css-extract-plugin
module.exports = {"giftWrapper":"gifts_giftWrapper__36VGW","wrapper":"gifts_wrapper__2jI9V","show":"gifts_show__rNOhY","lightWrapper":"gifts_lightWrapper__1SP0X","hide":"gifts_hide__3E4Ms"};